import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  last1vo29oleiqj36 as last,
  first58ocm7j58k3q as first,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { arrayListOf1fz8nib0ncbow as arrayListOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  indexOf1xbs558u7wr52 as indexOf,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  substring3saq8ornu0luv as substring,
  substringiqarkczpya5m as substring_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { removeLast3759euu1xvfa3 as removeLast } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function MPNode$Element$toString$lambda(it) {
  return it.e2() + '="' + it.f2() + '"';
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.xaw_1 = setOf(['p', 'ul', 'li', 'div', 'span', 'strong', 'b', 'em', 'cite', 'dfn', 'i', 'big', 'small', 'font', 'blockquote', 'tt', 'a', 'u', 'del', 's', 'strike', 'sup', 'sub', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'br']);
        this.yaw_1 = setOf(['href', 'target']);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var ElementClass;
function Element() {
  if (ElementClass === VOID) {
    class $ {
      constructor(tagName, attributes, children) {
        attributes = attributes === VOID ? HashMap().n8() : attributes;
        children = children === VOID ? ArrayList().w() : children;
        this.zaw_1 = tagName;
        this.aax_1 = attributes;
        this.bax_1 = children;
      }
      toString() {
        if (this.zaw_1 === 'br')
          return '<br>';
        var tmp = this.zaw_1;
        var tmp_0 = this.aax_1.d2();
        return '<' + tmp + ' ' + joinToString(tmp_0, ' ', VOID, VOID, VOID, VOID, MPNode$Element$toString$lambda) + '>' + joinToString(this.bax_1, '') + '<\/' + this.zaw_1 + '>';
      }
      cax() {
        if (!Companion_getInstance().xaw_1.t1(this.zaw_1))
          this.zaw_1 = 'span';
        this.aax_1.q3().x3(Companion_getInstance().yaw_1);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.bax_1.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          element.cax();
        }
      }
      hashCode() {
        var result = getStringHashCode(this.zaw_1);
        result = imul(result, 31) + hashCode(this.aax_1) | 0;
        result = imul(result, 31) + hashCode(this.bax_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Element()))
          return false;
        if (!(this.zaw_1 === other.zaw_1))
          return false;
        if (!equals(this.aax_1, other.aax_1))
          return false;
        if (!equals(this.bax_1, other.bax_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Element');
    ElementClass = $;
  }
  return ElementClass;
}
var TextClass;
function Text() {
  if (TextClass === VOID) {
    class $ {
      constructor(content) {
        this.dax_1 = content;
      }
      toString() {
        return this.dax_1;
      }
      cax() {
      }
      hashCode() {
        return getStringHashCode(this.dax_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Text()))
          return false;
        if (!(this.dax_1 === other.dax_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Text');
    TextClass = $;
  }
  return TextClass;
}
function parseMPNodes(_this__u8e3s4) {
  var stack = arrayListOf([new (Element())('*')]);
  // Inline function 'com.lightningkite.kiteui.dom.starts' call
  var current = 0;
  $l$loop_0: while (true) {
    var nextStart = indexOf(_this__u8e3s4, _Char___init__impl__6a9atx(60), current);
    if (nextStart === -1) {
      if (current < _this__u8e3s4.length) {
        var it = substring(_this__u8e3s4, current);
        // Inline function 'kotlin.text.isNotBlank' call
        if (!isBlank(it)) {
          last(stack).bax_1.v(new (Text())(it));
        }
      }
      break $l$loop_0;
    }
    if (current < nextStart) {
      var it_0 = substring_0(_this__u8e3s4, current, nextStart);
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(it_0)) {
        last(stack).bax_1.v(new (Text())(it_0));
      }
    }
    var nextEnd = indexOf(_this__u8e3s4, _Char___init__impl__6a9atx(62), nextStart + 1 | 0) + 1 | 0;
    if (nextEnd === 0) {
      // Inline function 'com.lightningkite.kiteui.dom.analyzeTagInside' call
      var this_0 = substring(_this__u8e3s4, nextStart + 1 | 0);
      var isStart = true;
      var hasEnd = false;
      var lastBuilt = '';
      var tagName = null;
      var kvs = HashMap().n8();
      var textEncountered = false;
      var inQuotes = false;
      var quoteChar = _Char___init__impl__6a9atx(34);
      var builder = StringBuilder().d1();
      var nextIsValue = false;
      var currentIsValue = false;
      var runFinish = false;
      var inductionVariable = 0;
      var last_0 = this_0.length;
      while (inductionVariable < last_0) {
        var char = charCodeAt(this_0, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        if (inQuotes) {
          if (char === quoteChar) {
            inQuotes = false;
            runFinish = true;
          } else {
            builder.xb(char);
          }
        } else {
          if (char === _Char___init__impl__6a9atx(47)) {
            runFinish = true;
            hasEnd = true;
            if (!textEncountered) {
              isStart = false;
            }
          } else if (char === _Char___init__impl__6a9atx(32)) {
            runFinish = true;
          } else if (char === _Char___init__impl__6a9atx(61)) {
            nextIsValue = true;
            runFinish = true;
          } else if (char === _Char___init__impl__6a9atx(39) || char === _Char___init__impl__6a9atx(34)) {
            runFinish = true;
            inQuotes = true;
            quoteChar = char;
          } else {
            textEncountered = true;
            builder.xb(char);
          }
        }
        if (runFinish) {
          runFinish = false;
          if (!(builder.a() === 0)) {
            var built = builder.toString();
            if (tagName == null) {
              tagName = built;
            } else if (currentIsValue) {
              // Inline function 'kotlin.collections.set' call
              var key = lastBuilt;
              kvs.s3(key, built);
            } else {
              // Inline function 'kotlin.collections.set' call
              kvs.s3(built, '');
            }
            if (nextIsValue) {
              nextIsValue = false;
              currentIsValue = true;
            } else {
              currentIsValue = false;
            }
            lastBuilt = built;
            builder.ch();
          }
        }
      }
      if (!(builder.a() === 0)) {
        var built_0 = builder.toString();
        if (tagName == null) {
          tagName = built_0;
        } else if (currentIsValue) {
          // Inline function 'kotlin.collections.set' call
          var key_0 = lastBuilt;
          kvs.s3(key_0, built_0);
        } else {
          // Inline function 'kotlin.collections.set' call
          kvs.s3(built_0, '');
        }
        builder.ch();
      }
      var tmp0 = toString(tagName);
      var tmp2 = isStart;
      var end = hasEnd;
      if (tmp2) {
        var newElement = new (Element())(tmp0, kvs);
        last(stack).bax_1.v(newElement);
        stack.v(newElement);
      }
      if (end || tmp0 === 'br') {
        var tmp$ret$8;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(stack, Collection())) {
            tmp = stack.i1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$8 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = stack.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.zaw_1 === tmp0) {
              tmp$ret$8 = true;
              break $l$block_0;
            }
          }
          tmp$ret$8 = false;
        }
        if (tmp$ret$8) {
          var tmp_0 = stack.p1();
          var tmp$ret$11;
          $l$block_1: {
            // Inline function 'kotlin.collections.indexOfLast' call
            var iterator = stack.u1(stack.p1());
            while (iterator.v6()) {
              if (iterator.x6().zaw_1 === tmp0) {
                tmp$ret$11 = iterator.w6();
                break $l$block_1;
              }
            }
            tmp$ret$11 = -1;
          }
          // Inline function 'kotlin.repeat' call
          var times = tmp_0 - tmp$ret$11 | 0;
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < times)
            do {
              var index = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              removeLast(stack);
            }
             while (inductionVariable_0 < times);
        }
      }
      break $l$loop_0;
    } else {
      // Inline function 'com.lightningkite.kiteui.dom.analyzeTagInside' call
      var this_1 = substring_0(_this__u8e3s4, nextStart + 1 | 0, nextEnd - 1 | 0);
      var isStart_0 = true;
      var hasEnd_0 = false;
      var lastBuilt_0 = '';
      var tagName_0 = null;
      var kvs_0 = HashMap().n8();
      var textEncountered_0 = false;
      var inQuotes_0 = false;
      var quoteChar_0 = _Char___init__impl__6a9atx(34);
      var builder_0 = StringBuilder().d1();
      var nextIsValue_0 = false;
      var currentIsValue_0 = false;
      var runFinish_0 = false;
      var inductionVariable_1 = 0;
      var last_1 = this_1.length;
      while (inductionVariable_1 < last_1) {
        var char_0 = charCodeAt(this_1, inductionVariable_1);
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        if (inQuotes_0) {
          if (char_0 === quoteChar_0) {
            inQuotes_0 = false;
            runFinish_0 = true;
          } else {
            builder_0.xb(char_0);
          }
        } else {
          if (char_0 === _Char___init__impl__6a9atx(47)) {
            runFinish_0 = true;
            hasEnd_0 = true;
            if (!textEncountered_0) {
              isStart_0 = false;
            }
          } else if (char_0 === _Char___init__impl__6a9atx(32)) {
            runFinish_0 = true;
          } else if (char_0 === _Char___init__impl__6a9atx(61)) {
            nextIsValue_0 = true;
            runFinish_0 = true;
          } else if (char_0 === _Char___init__impl__6a9atx(39) || char_0 === _Char___init__impl__6a9atx(34)) {
            runFinish_0 = true;
            inQuotes_0 = true;
            quoteChar_0 = char_0;
          } else {
            textEncountered_0 = true;
            builder_0.xb(char_0);
          }
        }
        if (runFinish_0) {
          runFinish_0 = false;
          if (!(builder_0.a() === 0)) {
            var built_1 = builder_0.toString();
            if (tagName_0 == null) {
              tagName_0 = built_1;
            } else if (currentIsValue_0) {
              // Inline function 'kotlin.collections.set' call
              var key_1 = lastBuilt_0;
              kvs_0.s3(key_1, built_1);
            } else {
              // Inline function 'kotlin.collections.set' call
              kvs_0.s3(built_1, '');
            }
            if (nextIsValue_0) {
              nextIsValue_0 = false;
              currentIsValue_0 = true;
            } else {
              currentIsValue_0 = false;
            }
            lastBuilt_0 = built_1;
            builder_0.ch();
          }
        }
      }
      if (!(builder_0.a() === 0)) {
        var built_2 = builder_0.toString();
        if (tagName_0 == null) {
          tagName_0 = built_2;
        } else if (currentIsValue_0) {
          // Inline function 'kotlin.collections.set' call
          var key_2 = lastBuilt_0;
          kvs_0.s3(key_2, built_2);
        } else {
          // Inline function 'kotlin.collections.set' call
          kvs_0.s3(built_2, '');
        }
        builder_0.ch();
      }
      var tmp0_0 = toString(tagName_0);
      var tmp2_0 = isStart_0;
      var end_0 = hasEnd_0;
      if (tmp2_0) {
        var newElement_0 = new (Element())(tmp0_0, kvs_0);
        last(stack).bax_1.v(newElement_0);
        stack.v(newElement_0);
      }
      if (end_0 || tmp0_0 === 'br') {
        var tmp$ret$21;
        $l$block_3: {
          // Inline function 'kotlin.collections.any' call
          var tmp_1;
          if (isInterface(stack, Collection())) {
            tmp_1 = stack.i1();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$21 = false;
            break $l$block_3;
          }
          var _iterator__ex2g4s_0 = stack.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            if (element_0.zaw_1 === tmp0_0) {
              tmp$ret$21 = true;
              break $l$block_3;
            }
          }
          tmp$ret$21 = false;
        }
        if (tmp$ret$21) {
          var tmp_2 = stack.p1();
          var tmp$ret$24;
          $l$block_4: {
            // Inline function 'kotlin.collections.indexOfLast' call
            var iterator_0 = stack.u1(stack.p1());
            while (iterator_0.v6()) {
              if (iterator_0.x6().zaw_1 === tmp0_0) {
                tmp$ret$24 = iterator_0.w6();
                break $l$block_4;
              }
            }
            tmp$ret$24 = -1;
          }
          // Inline function 'kotlin.repeat' call
          var times_0 = tmp_2 - tmp$ret$24 | 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < times_0)
            do {
              var index_0 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              removeLast(stack);
            }
             while (inductionVariable_2 < times_0);
        }
      }
      current = nextEnd;
    }
  }
  return first(stack).bax_1;
}
//region block: exports
export {
  parseMPNodes as parseMPNodes2ccjji1gwc8mn,
};
//endregion

//# sourceMappingURL=microparse.mjs.map
